import { notificationSchema } from "@features/vessel-call/vessel-call-status/PortServices/flow/utils";
import { z } from "zod";

const approveByOperationsBunkeringFieldsSchema = z.object({
  notes: z.string().optional(),
  attachment: z.any().optional(),
});

export const approveByOperationsBunkeringSchema = () =>
  approveByOperationsBunkeringFieldsSchema.merge(notificationSchema);

export type ApproveByOperationsBunkeringSchema = z.infer<
  ReturnType<typeof approveByOperationsBunkeringSchema>
>;
